import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12.5,
	height: 20,
	viewBox: "0 0 12.5 20",
	transform: "rotate(180deg)",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "Union_1",
		"data-name": "Union 1",
		d: "M2.853,20H0L8.618,10,0,0H3.9l8.6,10L3.9,20Z",
		fill: "#eff0f1"
	})]
});
const ForwardRef = forwardRef(SvgLeft);
export default ForwardRef;
